<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import VueCookies from 'vue-cookies';
  export default {
    name: 'App',
  };
</script>

<style>
  html,body{
    width: 100%;
    height: 100%;
  }
  #app {
    font-family: 'Microsoft YaHei';
    height: 100%;
    /*height: 100vh;*/
  }
</style>



// WEBPACK FOOTER //
// src/App.vue